import { DASHBOARD_BY_ID_PAGE, DASHBOARD_BY_ID_PATH } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const dashboardByIdRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: DASHBOARD_BY_ID_PAGE,
	path: DASHBOARD_BY_ID_PATH + '/:dashboardId/:mode?',
	layout: 'expanded',
});
